import React from 'react'
import { useIntl } from 'react-intl'
import { useProductListPage } from 'lib/modules/catalog'
import { Container, Title } from './styled'
import { Filter } from './components/Filter'

interface Props {
  categoryId?: number
  onApplyFilters?: () => void
  visibleItems?: number
  isDraft?: boolean
  isMulti?: boolean
}

export const LayeredNavMobile = ({
  categoryId,
  onApplyFilters,
  visibleItems = 6,
  isDraft = true,
  isMulti = true
}: Props) => {
  const intl = useIntl()
  const {
    isFetching,
    handleFilterChange,
    layeredNav,
    filters,
    setFilters,
    draftFiltersChanged
  } = useProductListPage({
    categoryId,
    withLayeredNav: true,
    draftMode: isDraft
  })

  return (
    <Container
      isFetching={isFetching}
    >
      {layeredNav?.appliedFilters && (
        <div>
          <Title>
            {isDraft ? (
              <button
                type='button'
                disabled={!draftFiltersChanged}
                onClick={() => {
                  setFilters(filters)
                  onApplyFilters?.()
                }}
              >
                {intl.formatMessage({ id: 'action.apply' })}
              </button>
            ) : (
              <p>
                {intl.formatMessage({ id: 'catalog.layeredNav.filterBy' })}
              </p>
            )}
          </Title>
          <ul>
            {layeredNav?.filterOptions.map(item => {
              return (
                <Filter
                  key={item.code}
                  isFetching={isFetching}
                  filterOptions={item}
                  handleFilterChange={handleFilterChange}
                  visibleItems={visibleItems}
                  isDraft={isDraft}
                  isMulti={isMulti}
                  onApplyFilters={onApplyFilters}
                />
              )
            })}
          </ul>
        </div>
      )}
    </Container>
  )
}
